import React from 'react';
import WorldHero from '../components/world/WorldHero';
import WorldTable from '../components/world/WorldTable';
import WorldQuantum from '../components/world/WorldQuantum';
import WorldCost from '../components/world/WorldCost';
import WorldSignal from '../components/world/WorldSignal';
import WorldCta from '../components/world/WorldCta';

const WorldPage = () => (
  <main>
    <WorldHero />
    <WorldTable />
    <WorldQuantum />
    <WorldCost />
    <WorldSignal />
    <WorldCta />
  </main>
);

export default WorldPage;